// FNP-585: read-only binding-drift sweep history. Two queries, both backed by the
// FNP-584 read-model on billing-api. listBindingDriftReports is Query-backed on the
// recordType-runStartedAt GSI (newest-first), never a Scan.

export const listBindingDriftReports = `
   query listBindingDriftReports($limit: Int, $nextToken: String) {
       listBindingDriftReports(limit: $limit, nextToken: $nextToken) {
           items {
              id
              runDate
              runStartedAt
              runCompletedAt
              accountsScanned
              driftDetectedCount
              repairedCount
              repairFailedCount
              repairCappedCount
              findingsS3Uri
              recordType
              created
              updated
           }
           nextToken
       }
   }
`;

export const getBindingDriftReport = `
   query getBindingDriftReport($id: ID!) {
       getBindingDriftReport(id: $id) {
         id
         runDate
         runStartedAt
         runCompletedAt
         accountsScanned
         driftDetectedCount
         repairedCount
         repairFailedCount
         repairCappedCount
         findings
         findingsS3Uri
         recordType
         created
         updated
       }
}`;
